import ScrollReveal from 'scrollreveal';

class ScrollAnimations {
  constructor() {
    this.scrollReveal = ScrollReveal();

    this.init();
  }

  init() {
    this.scrollReveal.reveal('.footer-branding__figure', {
      origin: 'bottom',
      duration: 500,
      viewFactor: 0.5,
      distance: '50%',
    });

    this.scrollReveal.reveal('.grid-block .tease', {
      beforeReveal: function(el) {
        el.classList.add('is-animating');
      },
      opacity: null,
      viewFactor: 0.25,
    });

    this.scrollReveal.reveal('.link-item', {
      beforeReveal: function(el) {
        el.classList.add('is-animating');
      },
      opacity: null,
      viewFactor: 0.25,
    });
  }

  deinit() {}
}

export default ScrollAnimations;
